import React from 'react'
import styled, { createGlobalStyle } from 'styled-components'
import reset from 'styled-reset'
import { Helmet } from 'react-helmet'

import { Flex, Box } from './ui/BuildingBlocks.js'
import { Text } from './ui/Font.js'
import { colors } from './ui/helpers.js'

const GlobalStyle = createGlobalStyle`
  ${reset}
  div {
      box-sizing: border-box !important;
  }
  body {
      font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen,
      Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
      color: rgba(0, 0, 0, 0.7);
      max-width: 100vw;
      overflow-x: hidden;
      box-sizing: border-box !important;
    }
    a {
        text-decoration: none;
    }
    a :hover {
        color: ${colors.text};
    }
    .gatsby-image-wrapper > div {
      background-color: transparent !important;
    }
 `

const Body = styled.main`
  overflow-x: hidden;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: ${(props) => props.bg || colors.lightGrey};
`

const Layout = ({ children, bg }) => {
  return (
    <>
      <Helmet></Helmet>

      <GlobalStyle />

      <Body bg={bg} flexDirection="column">
        {children}
      </Body>
    </>
  )
}
export default Layout
